import React from "react";

import img1 from "../assets/webp/gallery1.webp";
import img2 from "../assets/webp/gallery2.webp";
import img3 from "../assets/webp/gallery3.webp";
import img4 from "../assets/webp/gallery4.webp";
import img5 from "../assets/webp/gallery5.webp";
import img6 from "../assets/webp/gallery6.webp";
import img7 from "../assets/webp/gallery7.webp";
import img8 from "../assets/webp/gallery8.webp";
// import img9 from "../assets/webp/gallery9.webp";
// --- Dummy images ---
const DEFAULT_IMAGES = [
  {
    id: 1,
    src: img1,
    alt: "Coffee on peach background",
  },
  {
    id: 2,
    src: img2,
    alt: "Leaves on dark background",
  },
  {
    id: 3,
    src: img3,
    alt: "Minimal desk",
  },
  {
    id: 4,
    src: img4,
    alt: "Plant in glass vase",
  },
  {
    id: 5,
    src: img5,
    alt: "Pendant lamp over teal wall",
  },
  {
    id: 6,
    src: img6,
    alt: "Small branch minimal",
  },
  {
    id: 7,
    src: img7,
    alt: "Keyboard and notebook",
  },
  {
    id: 8,
    src: img8,
    alt: "Coffee cup top down",
  },
  // {
  //   id: 9,
  //   src: img8,
  //   alt: "White textures",
  // },
];


export default function Gallery({ images = DEFAULT_IMAGES }) {
  return (
     <div className="w-full">
  <h2 className="text-2xl md:text-3xl font-semibold mb-6">Photo Gallery</h2>

  <div
    className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-6 [&>figure]:break-inside-avoid rounded-2xl"
    style={{ columnGap: '1.5rem' }} // precise gap control (optional)
  >
    {images.map((img) => (
      <figure
        key={img.id}
        className="mb-6 overflow-hidden rounded-2xl shadow-sm ring-1 ring-black/5"
      >
        <img
          src={img.src}
          alt={img.alt}
          loading="lazy"
          className="w-full h-auto object-cover block rounded-2xl"
        />
        {img.caption && (
          <figcaption className="p-3 text-sm text-gray-700 bg-white">
            {img.caption}
          </figcaption>
        )}
      </figure>
    ))}
  </div>
</div>

  );
}

